import { hasPermission, ROLES, type Permission, type Role } from '@cp/shared';

/**
 * What the current account may do, evaluated from the same table the server
 * uses (TZ section 9).
 *
 * This hides controls an operator cannot use; it is not the check that protects
 * anything. Every route re-evaluates the same permission server-side, because a
 * button removed from a page is still an endpoint anyone can call.
 */
export function can(roles: readonly string[], permission: Permission): boolean {
  // A role the interface does not recognise grants nothing rather than
  // crashing the page: a newer server may know roles this build does not.
  const known = roles.filter((role): role is Role => (ROLES as readonly string[]).includes(role));
  return hasPermission(known, permission);
}
